<template>
    <div>
        {{ activeQueueCallsCount }}
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ALL_QUEUE_ID } from '@/enum/redesignQueueDashboardStatistics'
import { DefaultRowData } from '@/helpers/multiQueueDashboardRedesign'
import { answeredCallCountByQueueId } from '@/composables/useSharedQueueCallsData'

const props = defineProps<{
    queueId: string | number
    tableData: DefaultRowData[]
}>()

const activeQueueCallsCount = computed(() => {
    const countMap = answeredCallCountByQueueId.value

    if (props.queueId === ALL_QUEUE_ID) {
        let count = 0
        for (const row of props.tableData) {
            count += countMap.get(row.queue_id) || 0
        }
        return count
    }

    return countMap.get(props.queueId) || 0
})
</script>

<style scoped lang="scss">
</style>
